import React from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';
import posed from 'react-pose';

import ButtonSet from 'components/ButtonSet';

import { buttonBar } from 'settings';

const BarAnim = posed.div({
  enter: {
    opacity: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: 50,
  },
});

/**
 * @typedef ButtonBarProps
 * @property {string} className Custom class name(s) to add to the component, for styling without clashing with other
 *   implementations
 */

/**
 * A ButtonBar component that renders a set of buttons. Buttons and orientation are set in settings.js
 *
 * @param {ButtonBarProps} props ButtonBar props
 * @returns {JSX.Element} ButtonBar component
 */
const ButtonBar = ({ className = null }) => {
  const { buttons, orientation } = buttonBar;

  // sets a default button-bar class name and allows for additional class names to be passed in
  const buttonBarClasses = clsx('button-bar', className, {
    'button-bar--left': orientation === 'left',
    'button-bar--right': orientation === 'right',
    'button-bar--bottom': orientation === 'bottom',
    // 'button-bar--top': orientation === 'top',
  });

  return (
    <BarAnim key="BarAnim" className={buttonBarClasses}>
      {buttonBar && <ButtonSet buttons={buttons} orientation={orientation} />}
    </BarAnim>
  );
};

export default ButtonBar;

ButtonBar.propTypes = {
  className: PropTypes.string,
};
